import { reactive, computed } from 'vue';

export default function DriverOnboardingDocumentUpload(data = {}) {
  const state = reactive({
    driverLicenseId: data.driverLicenseId || '',
    insuranceDocId: data.insuranceDocId || '',
    licenseExpiryDate: data.licenseExpiryDate || '',
    insuranceExpiryDate: data.insuranceExpiryDate || '',
    hasLicenseDocument: data.hasLicenseDocument || false,
    hasInsuranceDocument: data.hasInsuranceDocument || false,
    driverLicenseFront: null,
    driverLicenseBack: null,
    insuranceDocFile: null,
    declaresNoExcessiveCancellations: data.declaresNoExcessiveCancellations || false,
    declaresNoExcessiveAtFaultClaims: data.declaresNoExcessiveAtFaultClaims || false,
    declaresNoExcessiveTotalClaims: data.declaresNoExcessiveTotalClaims || false,
  });

  const isFutureDate = (dateString) => {
    if (!dateString) return false;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const inputDate = new Date(dateString);
    return inputDate > today;
  };

  const validations = {
    hasDriverLicense: computed(() =>
      state.hasLicenseDocument ||
      (state.driverLicenseFront != null && state.driverLicenseBack != null)
    ),
    hasInsurance: computed(() => !!state.insuranceDocId || !!state.insuranceDocFile || state.hasInsuranceDocument),
    hasLicenseExpiry: computed(() => !!state.licenseExpiryDate),
    hasInsuranceExpiry: computed(() => !!state.insuranceExpiryDate),
    isLicenseExpiryFuture: computed(() => isFutureDate(state.licenseExpiryDate)),
    isInsuranceExpiryFuture: computed(() => isFutureDate(state.insuranceExpiryDate)),
    hasAllDeclarations: computed(() =>
      state.declaresNoExcessiveCancellations &&
      state.declaresNoExcessiveAtFaultClaims &&
      state.declaresNoExcessiveTotalClaims
    ),
  };

  // Split out from isValid so a caller can tell "documents outstanding" from
  // "documents fine, declarations not confirmed" and say which one it is.
  const hasAllDocuments = () => (
    validations.hasDriverLicense.value &&
    validations.hasInsurance.value &&
    validations.hasLicenseExpiry.value &&
    validations.hasInsuranceExpiry.value &&
    validations.isLicenseExpiryFuture.value &&
    validations.isInsuranceExpiryFuture.value
  );

  const isValid = () => hasAllDocuments() && validations.hasAllDeclarations.value;

  const toJSON = () => ({
    driverLicenseId: state.driverLicenseId,
    insuranceDocId: state.insuranceDocId,
    licenseExpiryDate: state.licenseExpiryDate,
    insuranceExpiryDate: state.insuranceExpiryDate,
    declaresNoExcessiveCancellations: state.declaresNoExcessiveCancellations,
    declaresNoExcessiveAtFaultClaims: state.declaresNoExcessiveAtFaultClaims,
    declaresNoExcessiveTotalClaims: state.declaresNoExcessiveTotalClaims,
  });

  return { state, validations, hasAllDocuments, isValid, toJSON };
}
